import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { useCopy } from 'utils/useCopy';
import { pathToApiTokensSettings } from '../../settingsIntegrationsApiTokens.view';
export const ApiTokensTableActions = ({ id, name, token, handleDeleteApiToken, }) => {
    const navigate = useAppNavigate();
    const [copyToClipboard, copyState] = useCopy();
    return (_jsxs(FlexBox, Object.assign({ flexDirection: "row" }, { children: [_jsx(Tooltip, Object.assign({ content: "View token", dark: true }, { children: _jsx(IconButton, { variant: "tertiary", icon: "eye", onClick: () => {
                        navigate({
                            path: `${pathToApiTokensSettings}/:id`,
                            params: {
                                path: {
                                    id,
                                },
                            },
                        });
                    } }) })), _jsx(Tooltip, Object.assign({ content: copyState.status === 'copied' ? 'Copied' : 'Copy token', dark: true }, { children: _jsx(IconButton, { variant: "tertiary", icon: copyState.status === 'copied' ? 'done' : 'copy', onClick: () => copyToClipboard(token) }) })), _jsx(Tooltip, Object.assign({ content: "Delete", dark: true }, { children: _jsx(IconButton, { variant: "tertiary", icon: "trash", onClick: () => handleDeleteApiToken({
                        id,
                        name,
                    }) }) }))] })));
};
